import { FILTERS_UPDATE, ORG_UNITS_DEFAULT_FOR_DAY_SET, LOGOUT } from '../../../actions/constants/types';

const initialFiltersState = {
  orgUnit: null,
  orgStructureDepth: 3,
  clinician: '',
  grades: [''],
  selectedTeam: null,
  orgUnitTeam: null,
};

function filters(state = initialFiltersState, action) {
  switch (action.type) {
    case FILTERS_UPDATE: {
      return { ...state, ...action.filter };
    }
    case ORG_UNITS_DEFAULT_FOR_DAY_SET: {
      return {
        ...state,
        selectedTeam: action.orgUnitId,
      };
    }
    case LOGOUT:
      return {
        ...state,
        selectedTeam: null,
      };
    default: {
      return state;
    }
  }
}

export default filters;
